/**
 * Word lists for auto-generated alias usernames (`<adjective><noun><digits>`).
 *
 * These live in `shared` because the client generates candidates (so rotation
 * costs nothing) and the API validates that a free alias's username actually
 * came from this vocabulary. The blocked-word list deliberately does *not* live
 * here — it is server-only so it cannot be read or pre-filtered by a client.
 *
 * Rules for editing, all enforced by `username-wordlists.test.ts` and by the
 * blocklist cross-check in `apps/api/src/utils/blocked-words.test.ts`:
 * - lowercase ASCII letters only, no digits, spaces, or punctuation
 * - no duplicates within a list
 * - every `adjective + noun + 3 digits` must fit `USERNAME_MAX_LENGTH`
 * - no `adjective + noun` pair may trip the blocked-word matcher
 *
 * Adding and removing entries is expected. Removing one does not invalidate
 * usernames already issued from it: `isGeneratedUsername` is only consulted when
 * a *new* free alias picks a name.
 *
 * @module constants/username-wordlists
 */
export const USERNAME_ADJECTIVES = [
    'amber',
    'ancient',
    'arctic',
    'autumn',
    'azure',
    'balmy',
    'brave',
    'breezy',
    'bright',
    'bronze',
    'calm',
    'candid',
    'cheerful',
    'civic',
    'clever',
    'cobalt',
    'cosmic',
    'crimson',
    'crisp',
    'curious',
    'daring',
    'deft',
    'distant',
    'eager',
    'earnest',
    'electric',
    'emerald',
    'fabled',
    'fearless',
    'fleet',
    'fluent',
    'frosty',
    'gallant',
    'gentle',
    'gilded',
    'glowing',
    'golden',
    'hardy',
    'hidden',
    'honest',
    'humble',
    'indigo',
    'ivory',
    'jolly',
    'keen',
    'kindly',
    'lively',
    'lucid',
    'lunar',
    'marble',
    'mellow',
    'merry',
    'mighty',
    'misty',
    'noble',
    'northern',
    'olive',
    'patient',
    'placid',
    'polar',
    'prime',
    'quiet',
    'rapid',
    'restless',
    'rugged',
    'sapphire',
    'scarlet',
    'serene',
    'silent',
    'silver',
    'solar',
    'stellar',
    'sterling',
    'stormy',
    'sunny',
    'swift',
    'tawny',
    'tidy',
    'tranquil',
    'upbeat',
    'urban',
    'valiant',
    'velvet',
    'verdant',
    'violet',
    'vivid',
    'western',
    'winter',
    'witty',
    'woven',
    'zesty',
];
export const USERNAME_NOUNS = [
    'acorn',
    'alder',
    'anchor',
    'anthem',
    'arbor',
    'arrow',
    'aspen',
    'atlas',
    'aurora',
    'badger',
    'beacon',
    'bramble',
    'breeze',
    'brook',
    'canyon',
    'cedar',
    'cinder',
    'cliff',
    'clover',
    'comet',
    'compass',
    'coral',
    'cove',
    'crane',
    'creek',
    'crest',
    'delta',
    'dune',
    'echo',
    'ember',
    'falcon',
    'fathom',
    'fern',
    'ferry',
    'fjord',
    'forest',
    'fossil',
    'garnet',
    'glacier',
    'glade',
    'granite',
    'grove',
    'harbor',
    'harvest',
    'hawk',
    'heron',
    'hollow',
    'horizon',
    'juniper',
    'kestrel',
    'lantern',
    'ledger',
    'lichen',
    'lupine',
    'lynx',
    'maple',
    'meadow',
    'meridian',
    'mesa',
    'meteor',
    'nectar',
    'nimbus',
    'oakwood',
    'orchard',
    'osprey',
    'otter',
    'paddle',
    'pebble',
    'pine',
    'plateau',
    'prairie',
    'quarry',
    'quartz',
    'quill',
    'rapids',
    'raven',
    'reef',
    'ridge',
    'river',
    'sable',
    'sequoia',
    'shale',
    'shore',
    'sparrow',
    'spire',
    'spruce',
    'summit',
    'thicket',
    'thistle',
    'tide',
    'timber',
    'trail',
    'tundra',
    'valley',
    'vessel',
    'willow',
    'zenith',
];
//# sourceMappingURL=username-wordlists.js.map